function Drag() {
  return (
    <svg width={9} height={12} viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.39 2.343A1.172 1.172 0 101.39 0a1.172 1.172 0 000 2.343zM7.351 2.343a1.172 1.172 0 100-2.343 1.172 1.172 0 000 2.343zM1.39 7.107a1.172 1.172 0 100-2.343 1.172 1.172 0 000 2.343zM7.351 7.107a1.172 1.172 0 100-2.343 1.172 1.172 0 000 2.343zM1.39 11.872a1.172 1.172 0 100-2.343 1.172 1.172 0 000 2.343zM7.351 11.872a1.172 1.172 0 100-2.343 1.172 1.172 0 000 2.343z"
        fill="#2F6C5E"
      />
    </svg>
  );
}

export default Drag;
